import React from 'react';

import {Video} from './styles';

interface VideoPlayerProps {
  source: string;
  type: string;
  onEnded?: () => void;
}

const VideoJS: React.FC<VideoPlayerProps> = ({source, type, onEnded}) => {
  return (
    <Video>
      <video controls onEnded={() => onEnded && onEnded()}>
        <source src={source} type={type} />
      </video>
    </Video>
  );
};

export default VideoJS;
